import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AIChatWidget from "@/components/AIChatWidget";
import SmoothScroll from "@/components/SmoothScroll";
import { LanguageProvider } from "@/lib/i18n";

import Home from "@/pages/Home";
import Machines from "@/pages/Machines";
import MachineDetail from "@/pages/MachineDetail";
import Technology from "@/pages/Technology";
import Sectors from "@/pages/Sectors";
import Cases from "@/pages/Cases";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import AIAssistant from "@/pages/AIAssistant";

import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import { AdminDashboard, AdminEquipos, AdminBlog, AdminCasos, AdminContactos } from "@/admin/pages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function RedirectSlug({ to }) {
  const { slug } = useParams();
  return <Navigate to={`${to}/${slug}`} replace />;
}

function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="bg-[#f7ebd9] min-h-screen pt-20">{children}</main>
      <Footer />
      <AIChatWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <SmoothScroll />
            <ScrollToTop />
            <Routes>
              {/* Admin Backoffice (no public layout) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="equipos" element={<AdminEquipos />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="casos" element={<AdminCasos />} />
                <Route path="contactos" element={<AdminContactos />} />
              </Route>

              {/* Public site */}
              <Route path="/*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/equipos-dermo-faciales" element={<Machines />} />
                    <Route path="/equipos-dermo-faciales/:slug" element={<MachineDetail />} />
                    <Route path="/tecnologia-dermo-facial" element={<Technology />} />
                    <Route path="/sectores-aparatologia-estetica" element={<Sectors />} />
                    <Route path="/casos-de-exito-dermo-facial" element={<Cases />} />
                    <Route path="/blog-dermo-facial" element={<Blog />} />
                    <Route path="/blog-dermo-facial/:slug" element={<BlogArticle />} />
                    <Route path="/contacto" element={<Contact />} />
                    <Route path="/asesor-dermo-facial-ia" element={<AIAssistant />} />
                    {/* Legacy redirects */}
                    <Route path="/maquinas" element={<Navigate to="/equipos-dermo-faciales" replace />} />
                    <Route path="/maquinas/:slug" element={<RedirectSlug to="/equipos-dermo-faciales" />} />
                    <Route path="/tecnologia" element={<Navigate to="/tecnologia-dermo-facial" replace />} />
                    <Route path="/sectores" element={<Navigate to="/sectores-aparatologia-estetica" replace />} />
                    <Route path="/casos-de-exito" element={<Navigate to="/casos-de-exito-dermo-facial" replace />} />
                    <Route path="/blog" element={<Navigate to="/blog-dermo-facial" replace />} />
                    <Route path="/blog/:slug" element={<RedirectSlug to="/blog-dermo-facial" />} />
                    <Route path="/asistente-ia" element={<Navigate to="/asesor-dermo-facial-ia" replace />} />
                  </Routes>
                </Layout>
              }/>
            </Routes>
          </BrowserRouter>
        </AdminAuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
